module.exports = __webpack_public_path__ + "img/phone.c4279360.png";